<script>
import AmbientVideoPlayer from '@rei/ambient-video-player';
import LandingBanner from '@rei/banner-component';
import { LandingContentBlock, LandingAction } from '@rei/landing-content-block';
import LandingImageComponent from '@rei/landing-image-component';
import { IconPlayFill } from '@rei/cedar';

export default {
  name: 'AmbientVideoInBanner',
  components: {
    AmbientVideoPlayer,
    LandingBanner,
    LandingContentBlock,
    LandingAction,
    LandingImageComponent,
    IconPlayFill,
  },
  props: {
    video: { type: Object, required: false, default: () => {} },
    content: { type: Object, required: true, default: () => {} },
    videoId: { type: String, required: false, default: '' },
    media: { type: Object, required: false, default: () => {} },
    bannerComponentProps: { type: Object, required: true, default: () => {} },
  },
  data() {
    return {
      // We want this button to be hardcoded/not authorable.
      buttonOverride: {
        modifier: 'secondary',
        target: 'javascript',
        tag: 'button',
        text: 'Watch video',
      },
    };
  },
  computed: {
    renderVideo() {
      const render = (this.video?.src?.mp4 || this.video?.src?.webm);
      return render;
    },
    renderImage() {
      const render = this.media?.xs || this.media?.sm || this.media?.images;
      return !!render;
    },
    buttonOverrideMap() {
      let ctaTheme = 'secondary';
      const {
        config: { theme } = {},
        actions: { allSecondaryButtons = false } = {},
      } = this.content || {};

      if (theme === 'inverse') {
        ctaTheme = 'dark-secondary';
      } else if (theme === 'sale-inverse') {
        ctaTheme = 'sale';
      }

      return {
        ...this.buttonOverride,
        modifier: allSecondaryButtons ? `${ctaTheme}` : 'secondary',
      };
    },
  },
};

</script>

<template>
  <div class="ambient-video-in-banner">
    <landing-banner v-bind="bannerComponentProps">
      <template #background>
        <ambient-video-player
          v-if="renderVideo"
          v-bind="video"
        />
        <landing-image-component
          v-if="renderImage"
          class="banner-with-subtext__image"
          v-bind="media"
        />
      </template>
      <template #content>
        <landing-content-block
          class="ambient-video-in-banner__foreground"
          v-bind="content"
        >
          <template #javascriptActions="{ javascriptActions }">
            <landing-action
              v-if="javascriptActions && javascriptActions[0]"
              v-bind="buttonOverrideMap"
              data-ui="open-modal-button"
              @click="$emit('open-youtube-video-modal')"
            >
              <template #landing-action-icon>
                <icon-play-fill />
              </template>
            </landing-action>
          </template>
        </landing-content-block>
      </template>
    </landing-banner>
  </div>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
.ambient-video-in-banner {

  .banner__frame {
    overflow: hidden;

    @include cdr-sm-mq-up {
      border-radius: $cdr-radius-softer;
    }

    .ambient-video {
      &--ready {
        position: static;
      }

      &__controls {
        z-index: 4; // Needs to be here to override content block
      }
    }
  }

  .ls-content-block {
    // This margin is necessary to not block the touch with content-block
    // the play icon button of the ambient video player
    padding: $cdr-space-four-x $cdr-space-one-x;
  }

  &__foreground {
    z-index: 2;

    .ls-content-block__heading {
      @include cdr-text-heading-serif-600;

      @include cdr-sm-mq-up {
        @include cdr-text-heading-serif-700;
      }

      @include cdr-md-mq-up {
        @include cdr-text-heading-serif-1000;
      }
    }
  }
}
</style>
